<rask-toggle-panel class="mt-1" label="Certifiering"
    [validationIcon]="validationIcon">
    <rask-virkeskop-validation-message
        entityType="certifikat"
        [entityGuid]="kontrakt.guid">
    </rask-virkeskop-validation-message>

    @for (certifikat of certifikatList; track $index; let first = $first) {
        <div class="mt-3">
            <rask-kontrakt-certifikat
                [groupName]="certifikat.certifikatstyp"
                [label]="first ? 'Typ av certifikat' : ''"
                [dto]="certifikat"
                [listObservable]="certifikatListObservable"
                (updated)="updateKontraktCertifikat($event)">
            </rask-kontrakt-certifikat>
        </div>
    }
</rask-toggle-panel>